import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../../css/chats/ImagePreviewModal.css';

export default function ImagePreviewModal({ open, onClose, imageUrl, alt = '' }) {
    useEffect(() => {
        if (!open) return;
        const onEsc = (e) => {
            if (e.key === 'Escape') onClose && onClose();
        };
        window.addEventListener('keydown', onEsc);
        return () => window.removeEventListener('keydown', onEsc);
    }, [open, onClose]);

    if (!open || !imageUrl) return null;

    return createPortal(
        <div className="image-preview-overlay" onClick={onClose}>
            <button className="image-preview-close" onClick={(e) => { e.stopPropagation(); onClose(); }} aria-label="Закрыть">
                ×
            </button>
            <div className="image-preview-container" onClick={(e) => e.stopPropagation()}>
                <img
                    src={imageUrl}
                    alt={alt}
                    className="image-preview-img"
                />
            </div>
        </div>,
        document.body
    );
}
